import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import {MAX_SIZE_IN_MB, MAX_SIZE, SVG_MIME_TYPE} from '../utils/consts';
import './SvgUploadError.less';
type Props = {
	rejectedFile?: File | null | undefined;
};

const getErrorMessage = (file: File) => {
	if (file.type !== SVG_MIME_TYPE) {
		return (
			<Trans i18nKey="dashboard.widgets.config.onlySvgType">
				Selected file type not accepted. Only SVGs are allowed.
			</Trans>
		);
	} else if (file.size > MAX_SIZE) {
		return (
			<Trans i18nKey="dashboard.widgets.config.tooBigFile" values={{maxSize: MAX_SIZE_IN_MB}}>
				<>
					Selected file is too big. Maximum allowed size is{' '}
					{{
						maxSize: MAX_SIZE_IN_MB
					}}{' '}
					MB.
				</>
			</Trans>
		);
	} else {
		return (
			<Trans i18nKey="dashboard.widgets.config.fileRejected">
				This file is not accepted, please select another.
			</Trans>
		);
	}
};

const SvgUploadError = ({rejectedFile}: Props) => {
	return rejectedFile ? (
		<div className="svg-upload-error" data-testid="svg-upload-error">
			<FontAwesomeIcon icon={faExclamationTriangle} size={'lg'} className="warning-icon" />
			<span className="warning-message">{getErrorMessage(rejectedFile)}</span>
		</div>
	) : null;
};

export default SvgUploadError;
